/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Empty_NullInputs */

const cs_draft_empty_null = /** @type {(inputs: Draft_Empty_NullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tuto šablonu není koncept. Organizace možná nemá aktivní šablonu.`)
};

const en_draft_empty_null = /** @type {(inputs: Draft_Empty_NullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No draft for this template. The organization may not have an active template.`)
};

/**
* | output |
* | --- |
* | "No draft for this template. The organization may not have an active template." |
*
* @param {Draft_Empty_NullInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_empty_null = /** @type {((inputs?: Draft_Empty_NullInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Empty_NullInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_empty_null(inputs)
	return cs_draft_empty_null(inputs)
});